<template>
  <div id="app" class="px-8mk pt-1.5 pb-4 lg:py-10">
    <div v-if='dataReady' class="mx-auto main-cont max-w-cont-mdmk lg:max-w-cont-lgmk">
      <router-view v-bind:appData="appData" :lang="language"/>
      <SettingsButton v-if="!accessState" v-on:click.native="settingsFN()" v-bind:name="appData.settings"></SettingsButton>
      <!-- <RouterLink to="/"><button class="mt-12">{{ appData.endstate.home }}</button></RouterLink> -->
    </div>
  </div>
</template>

<script>
import router from './router'
import axios from 'axios'
import SettingsButton from '@/components/SettingsButton.vue'

export default {
  name: 'Home',
  props: {
    // msg: String
  },
  data() {
    return {
      language: 'E',
      homeState: true,
      accessState: false,
      currScene: 'home',
      dataReady: false,
      appData: {},
    }
  },
  components: {
    SettingsButton
  },
  beforeMount(){
    const urlParams = new URLSearchParams(window.location.search);
    const param = urlParams.get('lang');

    if(param == 'fr'){
      this.language = 'F'
      document.documentElement.setAttribute('lang', 'fr');
    }
  },
  async mounted() {
    // get language from query string
    await this.loadLanguage()
  },
  methods: {
    settingsFN: function(){
      // alert('Settings')
    },
    nextScene: function(val){
      if(this.currScene == val){
        return;
      }

      this.currScene = val

      if(val == 'home'){
        this.homeState = true;
        val = '/'
      }else{
        this.homeState = false;
      }
      router.push(val)
    },
    loadLanguage: function(){
        axios.get('data/pressure_points-' + this.language +'.json')
        .then((response)=> {
            this.appData = response.data;
            this.dataReady = true;
        })
        .catch(error => console.log(error))
      },
  }
}
</script>

<style lang="scss">
html{
  // height: 100%;
  // background: rgb(238,218,227,1);
}

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: "Outfit", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // background: linear-gradient(0deg, rgba(238,218,227,1) 0%, rgba(238,218,227,1) 30%, rgba(255,255,255,1) 100%);
}

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }

// h3{
//   color: white !important;
// }

// button{
//   margin: 0 auto;
//   padding: 10px 40px;
//   border-radius: 50px;
// }

// button:hover{
//   color: white;
//   background-color: slategray;
// }



// .main-btn{
//   font-size: 1.5rem;
//   font-weight: 600;
//   margin: 0 auto;
//   padding: 0px 20px;
//   border-radius: 50px;
//   color: #442E82 !important;
//   background-color: white !important;
//   border: 1px solid white !important;
// }

// .main-btn:hover{
//   color: white !important;
//   background-color: transparent !important;
//   // border: 1px solid white !important;
// }

// .purple-btn{
//   margin: 0 auto;
//   padding: 10px 20px;
//   // padding-left: 40px;
//   border-radius: 50px;
//   color: white;
//   background-image: linear-gradient(90deg, #442E82, #612B78) !important;
//   border: 3px solid #442E82 !important;
// }

// .purple-btn:hover{
//   color: #442E82;
//   background-image: linear-gradient(90deg, white, white) !important;
//   border: 3px solid #442E82 !important;
// }

// .purple-btn::after{
//   content: '\f144';
//     font-family: FontAwesome;
//     font-style: normal;
//     font-weight: normal;
//     text-decoration: inherit;
//     margin-left:20px;
//     color:#F15E2A;
// }

// .answer-btn{
//   width: 100%;
//   margin: 0 auto;
//   padding: 10px;
//   padding-left: 40px;
//   padding-right: 20px;
//   border-radius: 50px;
//   color: white;
//   background-image: linear-gradient(90deg, #442E82, #612B78) !important;
//   border: 3px solid #442E82 !important;
// }

// .answer-btn:hover{
//   color: #442E82;
//   background-image: linear-gradient(90deg, white, white) !important;
//   border: 3px solid #442E82 !important;
// }

.homeView {
  opacity: 0;
  height: 1px;
  overflow: hidden;
}

.modal-outer{
  // width: 100%;
  // height: 750px;
  // border-radius: 50px;
  // background-color: #452E82;
  // padding: 20px;
}

// .modal-img{
//   width: 100%;
//   height: 100%;
//   border-radius: 38px;
//   border: 4px solid white;
//   background-color: grey;
//   padding: 60px;
// }

// .modal-content{
//   width: 100%;
//   // max-height: 100%;
//   border-radius: 28px;
//   border: 6px solid black;
//   background-color: white;
//   padding: 40px;
//   opacity: 1;
// }

.question{
    border: 3px solid #452E82;
  }

.main-cont {
  // font-family: "Outfit", sans-serif;
  // max-width: 1150px;
}

</style>
